import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import layout_en from './en/layout.json'
import layout_tr from './tr/layout.json'
import dashboard_en from './en/dashboard.json'
import dashboard_tr from './tr/dashboard.json'
import common_en from './en/common.json'
import common_tr from './tr/common.json'
import clients_en from './en/clients.json'
import clients_tr from './tr/clients.json'
import dijikolay_en from './en/dijikolay.json'
import dijikolay_tr from './tr/dijikolay.json'

i18n.use(initReactI18next).init({
    lng: 'tr',
    fallbackLng: 'tr',
    interpolation: {
        escapeValue: false,
    },
    ns: [
        'layout',
        'dashboard',
        'common',
        'clients'
    ],
    resources: {
        en: {
            layout: layout_en,
            dashboard: dashboard_en,
            common: common_en,
            dijikolay: dijikolay_en,
            clients: clients_en,
        },
        tr: {
            layout: layout_tr,
            dashboard: dashboard_tr,
            common: common_tr,
            clients: clients_tr,
            dijikolay: dijikolay_tr
        },
    },
});

export default i18n;
